import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import toast from 'react-hot-toast'
import _, { values } from 'lodash'
import * as Yup from 'yup'
import { useMutation } from '@apollo/client'
import beneficiary from '../../gql/beneficiary'
import InsurancePlans from '../Beneficiary/components/InsurancePlans'
import SubscriberDetails from '../Beneficiary/components/SubscriberDetails'
import { useNavigate } from 'react-router-dom'
import { Button, CircularProgress } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import eligibility from '../../gql/eligibility'
import AddIcon from '@mui/icons-material/Add'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { useTranslation } from 'react-i18next'

function removeSpecialCharacters (input) {
  return input.replace(/(\d+-|\-[a-zA-Z])|[^a-zA-Z\s]/g, '')
}

function AramcoAddBene ({
  item,
  chiReqRecord,
  patientName,
  setChiReqRecord,
  systemType,
  refetchGetById,
  setEligibilityId
}) {
  const { t } = useTranslation()
  const [addAddress, setAddAddress] = useState(false)
  const [isFormReset, setIsFormReset] = useState(false)
  const [payers, setPayers] = useState([])
  const [submitEligibility, setSubmitEligibility] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const currentDate = new Date()

  const [fromDate, setFromDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-01`
  )
  const [toDate, setToDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-${new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate()}`
  )

  const navigate = useNavigate()

  const [
    checkEligibility,
    { data: eligibilityData, loading: loadingData, error: errorData }
  ] = useMutation(eligibility.ELIGIBILITY_CHECK, {
    update (proxy, result) {
      toast.success(t('Data send to payer successfully!'))
      setEligibilityId(result.data.verificationRequest.transaction_id)
      onSuccessfulEligibilityRequestResponse(result.data)
    },
    onError (error) {
      onEligibilityResponseError(error.graphQLErrors[0])
    }
  })

  const onSuccessfulEligibilityRequestResponse = data => {
    if (!data.verificationRequest.nphies_err) {
      setShowLoader(false)
    } else {
      setShowLoader(false)
    }
  }

  const onEligibilityResponseError = error => {
    setShowLoader(false)

    toast.error(`${error?.message}`)
  }

  const [patientId, setPatientId] = useState(item ? item.id : null)
  const gender = [
    { id: 'male', name: t('Male') },
    { id: 'female', name: t('Female') },
    { id: 'unknown', name: t('Unknown') }
  ]

  const xdocumentTypes = [
    { id: 'iqama', name: t('Iqama') },
    { id: 'Resident Card', name: t('Resident Card') },
    { id: 'Passport', name: t('Passport') },
    { id: 'Visa', name: t('Visa') },
    { id: 'National Card', name: t('National Card') },
    { id: 'Medical Record Number', name: t('Medical Record Number') }
  ]

  const documentTypes = [
    { id: 'VP', name: t('VISA') },
    { id: 'PPN', name: t('Passport') },
    { id: 'PRC', name: t('Permanent Resident Card Number') },
    { id: 'MR', name: t('Medical record number') },
    { id: 'NI', name: t('National Card') }
  ]

  const nationalities = [
    { id: 'Saudi Arabia', name: t('Saudi Arabia') },
    { id: 'Afghanistan', name: t('Afghanistan') },
    { id: 'Albania', name: t('Albania') },
    { id: 'Aland Islands', name: t('Aland Islands') }
  ]

  const residencyTypes = [
    { id: 'iqama', name: t('Iqama') },
    { id: 'visa', name: t('Visitor') },
    { id: 'nationalId', name: t('Citizen or Resident') }
  ]

  const maritalStatuses = [
    { id: 'D', name: t('Divorced') },
    { id: 'L', name: t('Legally Separated') },
    { id: 'M', name: t('Married') },
    { id: 'U', name: t('Unmarried') },
    { id: 'W', name: t('Widowed') }
  ]
  const occupationOptions = [
    { id: 'administration', name: t('Administration') },
    { id: 'agriculture', name: t('Agriculture') },
    { id: 'business', name: t('Business') },
    { id: 'education', name: t('Education') },
    { id: 'housewife', name: t('Housewife') },
    { id: 'marine', name: t('Marine') },
    { id: 'medical field', name: t('Medical Field') },
    { id: 'military', name: t('Military') },
    { id: 'skilled worker', name: t('Skilled Worker') },
    { id: 'student', name: t('Student') },
    { id: 'oil industries', name: t('Oil Industries') },
    { id: 'unemployed', name: t('Unemployed') },
    { id: 'others', name: t('Others') },
    { id: 'unknown', name: t('Unknown') }
  ]
  const religionOptions = [
    { id: '1', name: t('Muslim') },
    { id: '2', name: t('Christian') },
    { id: '3', name: t('Judaism') },
    { id: '4', name: t('Buddhism') },
    { id: '5', name: t('Zoroastrian') },
    { id: '7', name: t('Hinduism') },
    { id: '8', name: t('Sikh') },
    { id: '9', name: t('Without') },
    { id: '98', name: t('Not available') },
    { id: '99', name: t('Not mentioned') },
    { id: '0', name: t('Other') }
  ]

  const bloodGroups = [
    { id: 'O+', name: 'O+' },
    { id: 'O-', name: 'O-' },
    { id: 'A+', name: 'A+' },
    { id: 'A-', name: 'A-' },
    { id: 'B+', name: 'B+' },
    { id: 'B-', name: 'B-' }
  ]

  const visaType = [
    { id: 6, name_ar: 'مرور', name_en: t('Transit') },
    {
      id: 10,
      name_ar: 'سياحية او سياحية - هيا',
      name_en: t('Tourism or Tourist - Haya')
    },
    { id: 14, name_ar: 'توصيل بضائع', name_en: t('Cargo Delivery') },
    { id: 23, name_ar: 'زيارة تجارية', name_en: t('Business Visit') },
    { id: 24, name_ar: 'زيارة عائلية', name_en: t('Family Visit') },
    { id: 21, name_ar: 'رجال اعمال', name_en: t('Businessmen') },
    { id: 22, name_ar: 'زيارة عمل', name_en: t('Work Visit') },
    { id: 27, name_ar: 'زيارة شخصية', name_en: t('Personal Visit') },
    { id: 40, name_ar: 'مرافق', name_en: t('Accompanying') },
    { id: 30, name_ar: 'زيارة فعالية', name_en: t('Event Visit') }
  ]

  const tableHeaders = [
    {
      name: 'House No./ Apartment'
    },
    {
      name: 'Street Name'
    },
    {
      name: 'City'
    },
    {
      name: 'State/Province'
    },
    {
      name: 'Country'
    },
    {
      name: 'Postal Code'
    }
  ]

  const onSuccessfulRequestResponse = data => {
    if (data.registerPatient) {
      toast.success('Successfully Added!')
      formik.resetForm()
      setChiReqRecord(null)
      setIsFormReset(true)
      setPatientId(data.registerPatient.data.id)
    } else {
    }
  }

  const onResponseError = error => {
    if (error?.message) {
      toast.error(`${error?.message}`)
    }
  }

  const [createPatient, { data, loading, error }] = useMutation(
    beneficiary.CREATE_PATIENT,
    {
      update (proxy, result) {
        onSuccessfulRequestResponse(result.data)
      },
      onError (error) {
        onResponseError(error.graphQLErrors[0])
      }
    }
  )

  const [
    editBeneficiary,
    { updatedData, loading: updatedLoading, updatedError }
  ] = useMutation(beneficiary.UPDATE_BENEFICIARY, {
    update (proxy, result) {
      onSuccessfulEditResponse(result.data)
    },
    onError (error) {
      onResponseError(error.graphQLErrors[0])
    }
  })

  const onSuccessfulEditResponse = data => {
    if (data?.updatePatient) {
      toast.success(data?.updatePatient?.message || 'Update Successfully!')
      formik.resetForm()
      setChiReqRecord(null)
      setIsFormReset(true)
      navigate('/eligibility')
      // refetch();
    } else {
    }
  }

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message)
    }
    if (updatedError?.graphQLErrors[0]?.message) {
      toast.error(updatedError?.graphQLErrors[0]?.message)
    }
  }, [error, updatedError])

  const formatInputData = postData => {
    return {
      start_date: currentDate.toISOString().substring(0, 10),
      end_date: currentDate.toISOString().substring(0, 10),
      payer_id: `${
        postData?.insurance_plans?.length > 0 &&
        postData?.insurance_plans[0]?.payer_id
      }`,
      patient_id: postData?.id,
      insurance_plan_id: `${
        postData?.insurance_plans?.length > 0 &&
        postData?.insurance_plans[0]?.id
      }`,
      purpose: ['benefits', 'validation', 'discovery'],
      is_new_born: false,
      is_referral: false
    }
  }

  const addData = values => {
    let data = _.cloneDeep(values)

    if (item) {
      data['id'] = item.id

      if (data?.insurance_plans) {
        data.insurance_plans = data.insurance_plans.map(plan => {
          const { payer, ...rest } = plan
          return rest
        })
      }
      delete data.beneficiary_file_id

      editBeneficiary({ variables: { input: data } }).then(res => {
        refetchGetById()
        if (submitEligibility) {
          toast.loading(t('Checking Eligibility'))
          checkEligibility({
            variables: {
              input: formatInputData(values)
            }
          })
        }
      })
    } else {
      delete data.beneficiary_file_id
      createPatient({ variables: { input: data } }).then(res => {
        if (submitEligibility) {
          toast.loading(t('Checking Eligibility'))
          checkEligibility({
            variables: {
              input: formatInputData(res?.data?.registerPatient?.data)
            }
          })
        }
      })
    }
  }

  const threeMonthsAgo = new Date()
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3)

  const formik = useFormik({
    initialValues: {
      address_line: '',
      blood_group: '',
      border_no: '',
      city: '',
      contact_number: '',
      country: '',
      dob: threeMonthsAgo.toISOString().substring(0, 10),
      document_id: chiReqRecord,
      document_type: 'NI',
      eHealth_id: '',
      email: '',
      emergency_number: '',
      family_name: '',
      file_no: '',
      first_name: patientName,
      full_name: patientName,
      gender: 'male',
      id: '',
      insurance_duration: '',
      insurance_plans: [
        {
          member_card_id: '111111111',
          policy_number: '000000000',
          expiry_date: '2026-05-20',
          is_primary: true,
          payer_id: '1',
          relation_with_subscriber: 'self',
          patient_share: '20.00',
          max_limit: 100,
          network: '300318',
          issue_date: '2025-05-21',
          sponsor_no: '101010101010',
          policy_class_type: 'plan',
          policy_holder: 'checkingpolicy',
          insurance_type: '',
          insurance_status: '',
          insurance_duration: '',
          policy_class_name: '',
          coverage_type: 'Extended Healthcare',
          policy_class_id: 'a'
        }
      ],
      is_new_born: false,
      last_name: '',
      martial_status: 'U',
      middle_name: '',
      nationality: '',
      nphies_id: '',
      occupation: 'others',
      passport_no: '',
      postal_code: '',
      preferred_language: '',
      religion: '1',
      residency_type: 'nationalId',
      state: '',
      street_line: '',
      subscriber_id: '',
      subscriber_insurance_plan: '',
      subscriber_relationship: '',
      visa_no: '',
      visa_title: '',
      visa_type: ''
    },
    enableReinitialize: true,

    onSubmit: (values, { setSubmitting }) => {
      if (removeSpecialCharacters(values.full_name).trim() === '') {
        toast.error(t('invalid name'))
        return
      }
      console.log({
        ...values,
        full_name: removeSpecialCharacters(values.full_name),
        first_name: removeSpecialCharacters(
          values.first_name || values.full_name
        )
      })

      addData({
        ...values,
        full_name: removeSpecialCharacters(values.full_name),
        first_name: removeSpecialCharacters(
          values.first_name || values.full_name
        )
      })
    }
  })

  useEffect(() => {
    if (chiReqRecord) {
      const firstChar = chiReqRecord.charAt(0)
      if (firstChar == '1') {
        formik.setFieldValue('document_type', 'NI')
        formik.setFieldValue('residency_type', 'nationalId')
      } else if (firstChar == '2') {
        formik.setFieldValue('document_type', 'PRC')
        formik.setFieldValue('residency_type', 'iqama')
      } else if (firstChar == '4') {
        formik.setFieldValue('document_type', 'VP')
        formik.setFieldValue('residency_type', 'visa')
      }
    }
  }, [chiReqRecord])

  React.useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem('payersData'))

    if (payersData && payersData.length > 0) {
      setPayers(payersData)
    } else {
      navigate('/dashboard')
    }
  }, [])

  useEffect(() => {
    if (chiReqRecord) formik.handleSubmit()
  }, [chiReqRecord])
  return (
    <>
      <div className=' flex gap-3 justify-center'></div>
    </>
  )
}

export default AramcoAddBene
